import { atom } from 'recoil';
import { Customer, Gender, TZuchiAgeLevel } from '~/types/platform/customer';

const customer = atom<Customer>({
  key: 'customer',
  default: {
    displayName: '',
    phoneNumber: '',
    gender: Gender.EMPTY,
    age: TZuchiAgeLevel.Empty,
    isLoginFormSubmitted: null,
    email: '',
    birthday: '',
    totalDiscount: 0,
    containers: {},
    containerNodeId: '',
  },
});

export default customer;
